import { render } from "./OfficeDetailView.vue?vue&type=template&id=177244b8"
import script from "./OfficeDetailView.vue?vue&type=script&lang=js"
export * from "./OfficeDetailView.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/production/declic-center-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__